import React from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';

import { gameTypes } from 'config/promoGameTypes';
import { below } from 'utils/breakpoint';
import { statuses } from 'editor/game_checkIn/components/lotteryTaskCarousel/LotteryTaskCard';

export default function LotteryTaskProcessHint({
    gameType,
    recordsLength,
    cards = [],
    componentStyle = {},
    style = false
}) {
    const { t } = useTranslation();

    if (cards.length === 0) {
        return null;
    }

    const firstCheckPoint = cards[0].taskCondition ?? 0;
    const lastCheckPoint = cards[cards.length - 1].taskCondition ?? 0;
    const text = (() => {
        const texts = getTextsByGameType(gameType);
        if (recordsLength === 0) {
            return t(texts.START, { count: firstCheckPoint });
        }
        if (recordsLength >= lastCheckPoint) {
            return t(texts.ALL);
        }
        if (recordsLength < lastCheckPoint) {
            const next = cards.find(
                c => c.status !== statuses.PRIZE_EMPTY && c.taskCondition > recordsLength
            );
            return Boolean(next)
                ? t(texts.MORE, {
                      count: next.taskCondition - recordsLength
                  })
                : t(texts.DONE);
        }
        return '';
    })();

    return (
        Boolean(text) && (
            <Typography variant="h6" css={[textStyle(componentStyle), css(style)]}>
                {text}
            </Typography>
        )
    );
}

function getTextsByGameType(gameType) {
    switch (gameType) {
        case gameTypes.MULTI_CHALLENGE:
        case gameTypes.CHALLENGE_PHOTO_FRAME_COMPOSITE:
            return {
                START: 'label.challenge.progress.start',
                ALL: 'label.check_in.progress.all',
                MORE: 'label.challenge.progress.more',
                DONE: 'label.check_in.progress.done'
            };
        case gameTypes.CHECK_IN:
        default:
            return {
                START: 'label.check_in.progress.start',
                ALL: 'label.check_in.progress.all',
                MORE: 'label.check_in.progress.more',
                DONE: 'label.check_in.progress.done'
            };
    }
}

const textStyle = ({ descColor }) => css`
    padding-top: 2px;
    text-align: center;
    color: ${descColor};
    ${below('sm')} {
        padding-top: 24px;
        font-size: 0.875rem;
    }
`;
